const PhoneSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <rect
      width={32}
      height={32}
      fill={window.APP_VENDOR === "snai" ? "#fff" : "#0B7D3E"}
      rx={16}
    />
    <rect
      width={31}
      height={31}
      x={0.5}
      y={0.5}
      fill={window.APP_VENDOR === "snai" ? "#2E3845" : "#fff"}
      rx={15.5}
    />
    <rect
      width={31}
      height={31}
      x={0.5}
      y={0.5}
      stroke={window.APP_VENDOR === "snai" ? "#9CABC0" : "#0B7D3E"}
      rx={15.5}
    />
    <path
      fill={window.APP_VENDOR === "snai" ? "#2E3845" : "#fff"}
      fillRule="evenodd"
      stroke={window.APP_VENDOR === "snai" ? "#EBFF00" : "#0B7D3E"}
      strokeWidth={0.4}
      d="m20.084 17.838 1.936 1.353c.557.39.787 1.091.56 1.707a2.688 2.688 0 0 1-.24.49l-.188.27c-.06.078-.117.14-.176.2a2.683 2.683 0 0 1-1.227.687c-.301.081-.632.122-.983.122-2.048 0-4.683-1.363-6.876-3.557-2.612-2.611-3.992-5.77-3.435-7.86.131-.487.362-.9.688-1.226.06-.06.122-.116.189-.168l.267-.188c.162-.102.327-.182.504-.248.156-.057.32-.086.486-.086.482 0 .938.241 1.22.646l1.353 1.936a1.489 1.489 0 0 1-.37 2.08l-.644.45c.505.753 1.21 1.594 2.011 2.395.801.801 1.642 1.506 2.395 2.012l.45-.645a1.494 1.494 0 0 1 2.08-.37Zm1.759 3.22c.062-.1.124-.227.176-.367.133-.36-.007-.776-.341-1.01l-1.936-1.353a.92.92 0 0 0-1.248.222l-.616.882a.3.3 0 0 1-.404.082c-.847-.534-1.82-1.333-2.737-2.25-.918-.918-1.716-1.89-2.25-2.739a.299.299 0 0 1 .082-.404l.881-.614a.894.894 0 0 0 .222-1.25l-1.352-1.935a.898.898 0 0 0-.73-.39.805.805 0 0 0-.28.05 2.073 2.073 0 0 0-.38.184l-.243.17c-.035.028-.079.069-.121.11-.25.252-.43.574-.533.96-.496 1.86.852 4.854 3.28 7.282 2.085 2.085 4.558 3.38 6.453 3.381.3 0 .578-.034.829-.1.385-.104.707-.283.958-.534.042-.042.082-.085.12-.133l.17-.244Z"
      clipRule="evenodd"
    />
  </svg>
)
export { PhoneSvg }
